module.exports = __webpack_public_path__ + "static/media/icons.dc332a5c.svg";